import { Action, Store } from '@reduxjs/toolkit';
import { ReactiveControllerHost } from 'lit';
import { ApiRequestState, ApiSliceState, selectors } from '../api-slice';
import { ReduxController } from './redux-controller';

export abstract class ApiReduxController<S> extends ReduxController<S>  {
  constructor(host: ReactiveControllerHost, store: Store<S, Action<any>>) {
    super(host, store);
  }
  
  protected abstract get apiStatusState(): ApiSliceState;

  getNewestRequestStatus(endpoint: string): ApiRequestState | undefined {
    return selectors.getNewestRequestStatus(this.apiStatusState, endpoint);
  }

  getRequestStatus(endpoint: string, requestId?: string): ApiRequestState | undefined {
    return selectors.getRequestStatus(this.apiStatusState, endpoint, requestId);
  }

  isRequestLoading(endpoint: string, requestId?: string) {
    return selectors.isRequestLoading(this.apiStatusState, endpoint, requestId);
  }
  
  requestError(endpoint: string, requestId?: string) {
    return selectors.requestError(this.apiStatusState, endpoint, requestId);
  }

  requestCompleted(endpoint: string, requestId?: string) {
    return selectors.requestCompleted(this.apiStatusState, endpoint, requestId);
  }
}
